import environment, { Environment } from "../../../environments/base";

/*
 * base.ts is the default environment for production.
 * You shouldn't have override anything.
 */
const baseApi = "https://cqs.csebo.it/italcredi_easymoney/services";
const env = environment(baseApi);

const productionEnv: Environment = {
    ...env,
    // override anything that gets added from base.
    basePathDeploy: "/italcredi_easymoney",
    visualizzaCampiBonifico: true,
    visualizzaCampiDatiReddito: true,
    attivaScriptTracciamento: true,
    attivaCalcoloRedditualeID289: true,
    attivaAdeguataVerifica: false,
    richiestaSteps: ["ANAG", "REDD", "PREST", "DOC", "RICON", "FIRMA", "CONCLUDI", "END"],
    attivaCampiNomeCognome: true,
    attivaPreSelezionePensionato: false,
    attivaPreselezioneCatAmmin: true,
    visualizzaAltriImpegniNelTabPrestiti: true,
    attivaGestioneConsensi: true,
    visualizzaDisclaimerPreventivo: true,
};

export default productionEnv;
